// extracted by css-extract-rspack-plugin
export default {"dialogMargin":"DialogCreateBody_dialogMargin__bzWUh","sendButton":"DialogCreateBody_sendButton__OD6Ti"};